export default {
  default: {
    container: "max-w-4xl mx-auto bg-paper px-4 py-8",
    title: "text-3xl sm:text-4xl md:text-5xl font-semibold text-center mb-8",
    item: "border-b border-bordered py-4",
    question:
      "flex justify-between items-center w-full text-left focus:outline-none",
    question_text: "text-xl md:text-2xl text-text",
    toggle: "text-neutral_3 text-2xl",
    motion_container: "overflow-hidden",
    answer: "mt-2 text-neutral_3",
  },

  admin: {
    container: "max-w-4xl mx-auto bg-admin_paper px-4 py-8",
    title: "text-3xl sm:text-4xl md:text-5xl font-semibold text-center mb-8",
    item: "border-b border-admin_bordered py-4",
    question: "flex justify-between items-center w-full text-left focus:outline-none",
    question_text: "text-xl md:text-2xl text-admin_text",
    toggle: "text-admin_neutral_3 text-2xl",
    motion_container: "overflow-hidden",
    answer: "mt-2 text-admin_neutral_3",
  },

  dark: {
    container: "max-w-4xl mx-auto bg-gray-900 px-4 py-8",
    title:
      "text-3xl sm:text-4xl md:text-5xl font-semibold text-center mb-8 text-text_inv",
    item: "border-b border-bordered py-4",
    question:
      "flex justify-between items-center w-full text-left focus:outline-none",
    question_text: "text-xl md:text-2xl text-text_inv",
    toggle: "text-neutral_2 text-2xl",
    motion_container: "overflow-hidden",
    answer: "mt-2 text-neutral_2",
  },

  admin_dark: {
    container: "max-w-4xl mx-auto bg-gray-900 px-4 py-8",
    title: "text-3xl sm:text-4xl md:text-5xl font-semibold text-center mb-8 text-admin_text_inv",
    item: "border-b border-admin_bordered py-4",
    question: "flex justify-between items-center w-full text-left focus:outline-none",
    question_text: "text-xl md:text-2xl text-admin_text_inv",
    toggle: "text-admin_neutral_2 text-2xl",
    motion_container: "overflow-hidden",
    answer: "mt-2 text-admin_neutral_2",
  },

  minimal: {
    container: "max-w-4xl mx-auto px-4 py-4",
    title: "text-2xl font-semibold text-center mb-4",
    item: "border-b border-bordered py-2",
    question:
      "flex justify-between items-center w-full text-left focus:outline-none hover:text-primary",
    question_text: "text-lg text-text",
    toggle: "text-neutral_3",
    motion_container: "overflow-hidden",
    answer: "mt-2 text-neutral_3 text-sm",
  },

  admin_minimal: {
    container: "max-w-4xl mx-auto px-4 py-4",
    title: "text-2xl font-semibold text-center mb-4",
    item: "border-b border-admin_bordered py-2",
    question: "flex justify-between items-center w-full text-left focus:outline-none hover:text-admin_primary",
    question_text: "text-lg text-admin_text",
    toggle: "text-admin_neutral_3",
    motion_container: "overflow-hidden",
    answer: "mt-2 text-admin_neutral_3 text-sm",
  },

  elevated: {
    container: "max-w-4xl mx-auto px-4 py-8",
    title: "text-3xl font-bold text-center mb-8",
    item: "shadow-md rounded-lg p-4 my-2 bg-paper",
    question:
      "flex justify-between items-center w-full text-left focus:outline-none hover:text-primary",
    question_text: "text-xl font-semibold text-text",
    toggle:
      "w-6 h-6 rounded-full bg-neutral_1 flex items-center justify-center text-neutral_3",
    motion_container: "overflow-hidden",
    answer: "mt-4 text-neutral_3 pl-2",
  },

  admin_elevated: {
    container: "max-w-4xl mx-auto px-4 py-8",
    title: "text-3xl font-bold text-center mb-8",
    item: "shadow-md rounded-lg p-4 my-2 bg-admin_paper",
    question: "flex justify-between items-center w-full text-left focus:outline-none hover:text-admin_primary",
    question_text: "text-xl font-semibold text-admin_text",
    toggle: "w-6 h-6 rounded-full bg-admin_neutral_1 flex items-center justify-center text-admin_neutral_3",
    motion_container: "overflow-hidden",
    answer: "mt-4 text-admin_neutral_3 pl-2",
  },
}
